import { cva } from 'class-variance-authority';

export const stepperVariants = cva(
  [
    'inline-flex',
    'w-fit',
    'items-center',
    'rounded-radius-comp-stepper',
    'bg-color-comp-stepper-container',
    'text-color-comp-stepper-on-container',
  ],
  {
    variants: {
      size: {
        tiny: [
          'px-spacing-comp-stepper-tiny-horizontal',
          'py-spacing-comp-stepper-tiny-vertical',
          'gap-spacing-comp-stepper-tiny-gap',
        ],
        small: [
          'px-spacing-comp-stepper-small-horizontal',
          'py-spacing-comp-stepper-small-vertical',
          'gap-spacing-comp-stepper-small-gap',
        ],
        medium: [
          'px-spacing-comp-stepper-medium-horizontal',
          'py-spacing-comp-stepper-medium-vertical',
          'gap-spacing-comp-stepper-medium-gap',
        ],
      },
    },
  },
);
